// Drift: Bogholderi › Oprydning på Supabase (del af SupabaseApi – se supabase.ts). Funktionerne i 20261107170000_oprydning.sql
// tjekker rettighed (se: betalinger.se, markér/send: betalinger.ret), kategori, Likvido, e-conomic, loftet pr. dag og spærren.
// oprydning_send godkender rækkerne (hvem og hvornår logges) og lægger opkrævningerne i kø; send-mail/send-besked sætter
// betalingslinket ind og tjekker undtagelsen fra spærren igen, lige før der sendes.
import { ApiFejl, type Api, type OprydFilter, type OprydListe } from './api';
import type { SbKontekst } from './sbKatalog';

export class SbOprydning {
  constructor(private readonly c: SbKontekst) {}
  private async rpc<T>(navn: string, args: Record<string, unknown> = {}): Promise<T> {
    return (await this.c.k(this.c.sb.rpc(navn, { k: await this.c.kraevKlient(), ...args }))) as T;
  }

  oprydningListe: Api['oprydningListe'] = (f: OprydFilter = {}) => this.rpc<OprydListe>('oprydning_liste', {
    p_aar: f.aar ?? null, p_brand: f.brand ?? null, p_kategori: f.kategori ?? null, p_fra: f.fra ?? 0, p_antal: f.antal ?? 50,
  });
  oprydningMarker: Api['oprydningMarker'] = async (ids, handling) => {
    const n = await this.rpc<number>('oprydning_marker', { p_ids: ids, p_handling: handling });
    this.c.skift();
    return n;
  };
  oprydningSend: Api['oprydningSend'] = async (i) => {
    if (!i.ids.length) throw new ApiFejl('Vælg mindst én kunde.');
    if (!i.kanaler.length) throw new ApiFejl('Vælg mail og/eller SMS.');
    const svar = await this.rpc<Awaited<ReturnType<Api['oprydningSend']>>>('oprydning_send', {
      p_ids: i.ids, p_mode: i.mode, p_kanaler: i.kanaler, p_emne: i.emne, p_tekst: i.tekst, p_test: !!i.test,
    });
    this.c.skift();
    return svar;
  };
  oprydningOpdater: Api['oprydningOpdater'] = async () => { const n = await this.rpc<number>('oprydning_opdater'); this.c.skift(); return n; };
}
